__webpack_require__.p = "/refactoractivitiesnotifications-part-2-gt6pp8/referrals/";